import { Typography } from '@/src/shared/components/Typography';
import styles from './HeroSection.module.scss';
import Video from './Video';
import { useIsMobile } from '@/src/shared/hooks/utils/useIsMobile';
import { Section } from '@/src/containers/Landings/Section';

export const HeroSection = () => {
  const isMobile = useIsMobile();

  return (
    <Section className={styles.container}>
      <div className={styles.videoWrapper}>
        <Video />
      </div>
      <div className={styles.titleWrapper}>
        <Typography
          tag={isMobile ? 'h4' : 'h3'}
          variant="heading"
          size={isMobile ? 'h4' : 'h3'}
        >
          {`VuSocial,\na Content Factory at Scale`}
        </Typography>
        <Typography tag="span" variant="text" size="xl" fontWeight="regular">
          VuSocial helps insurance agents and financial advisors grow their
          brand effortlessly with daily, branded videos—featuring your face,
          voice, and expertise.
        </Typography>
      </div>
    </Section>
  );
};
